module.exports = __webpack_public_path__ + "img/9788960514065.21616ef8.jpg";